import React from "react"
export function DownChevron(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__down-chevron"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M9.48 13.79a.75.75 0 00.948.076l.091-.075L17.5 7.074 16.461 6 10 12.217 3.54 6 2.5 7.074l6.98 6.717z"
          id="prefix__down"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
